import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { brandActions } from "redux/actions/brand-actions";
import Select from "react-select";
import { helperFunctions as HF } from "../../../helper/helperFunctions";
import { createOrderActions } from "../../../redux/actions/create-order-actions";

class BrandsDropdownLinks extends Component {
    constructor(props) {
        super(props);
        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
        this.state = {
            ...this.props.stateProp,
            user_role: user.roles[0].name,
            brandsData: [],
            selected_value: "",
            selectFirst: (this.props.selectFirst && this.props.selectFirst === 'true') ? true : false
        };
    }

    componentDidMount() {

        if (this.state.user_role === 'customer manager') {
            this.props.getAllBrandsCall();
        }
        else {
            this.props.getDropDownList(1, "", "", 10).then(res => {
                if (this.state.selectFirst && this.props.brandsData.length > 0) {
                    this.setState({
                        selected_value: Number(this.props.brandsData[0].id),
                    });
                }
            });
        }

        if (this.props.match.params.brandId) {
            this.setState({
                selected_value: Number(this.props.match.params.brandId),
            })
        }
        else if (this.props.match.params.id) {
            this.setState({
                selected_value: Number(this.props.match.params.id),
            })
        }
    }
    handleChange = (selectedOption) => {
        this.setState({
            selected_value: selectedOption.id
        });
    };
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selected_value !== prevState.selected_value) {
            this.props.returnModelId(this.state.selected_value);
        }

        if (this.props.brands !== prevProps.brands) {
            const newArray = this.props.brands.map(data => {
                data.id = data.brand_id
                return data
            })
            this.setState({
                brandsData: newArray
            })
        }

        if (this.props.brandsData !== prevProps.brandsData) {
            this.setState({
                brandsData: this.props.brandsData
            })
        }

        if (this.props.synced_brand_id !== prevProps.synced_brand_id && this.props.synced_brand_id !== undefined) {
            this.setState({
                selected_value: this.props.synced_brand_id
            });
        }
    }

    render() {
        const { brandsData } = this.state;
        return (
            <div className="flexElem alignCenter">
                <div
                    className="col-md-4 no-padding"
                >
                    Currently Editing:
                </div>
                <div className="col-md-8 no-padding brandsDropdown">
                    <Select
                        value={HF.returnTitleWithId(this.state.selected_value, this.state.brandsData)}
                        onChange={this.handleChange}
                        options={brandsData ? brandsData.sort((a, b) => a.title.localeCompare(b.label)) : []}
                        isSearchable={true}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        isMulti={false}
                        placeholder={"Select Brand"}
                    />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDropDownList: (page, filter, sort, pageSize) => {
            return dispatch(
                brandActions.getBrandsListDropDown(page, filter, sort, pageSize)
            );
        },
        getAllBrandsCall: () => {
            return dispatch(
                createOrderActions.getCustomerBrandsList()
            );
        },
    };
};

function mapStateToProps(state) {
    const { brandsData } = state.brandReducer;
    const { brands } = state.createOrdersReducer;
    return {
        brandsData,
        brands
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandsDropdownLinks));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandsDropdownLinks.jsx